var isScrollifyMove = false;
var isAnchorScroll = false;
var isFirstLoaded = false;
$(document).ready(function () {
	
	localNav.init();
	kvAnim.init();
	$('.init').addClass('ready').removeClass('init');
	if (!ua.isTouchDevice){
		$.scrollify({
			section:".kv_scrl_block",
			setHeights:false,
			standardScrollElements: ".none_scrollify",
			scrollSpeed:750,
			updateHash:false,
			before:function(i){
				isScrollifyMove = true;
				kvAnim.leave();
				kvAnim.copyStep($('.kv_scrl_block').eq(i),i);
			},              
			after:function(i){
				isScrollifyMove = false;
			}
		});
	}

	$('.watch_the_video a').click(function(){
		let id = $(this).attr('data-id');
		vnsModal.youtubeOpen(id);
		return false;
	})

	//Anchor
	//-------------------------------------------
	$('.product_anchor_link[href^="#"]').click(function() {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position;

		if (target.length) {
			position = target.offset().top;
		} else {
			position = 0;
		}
		$.scrollify.disable();
		isAnchorScroll = true;

		autoScroll(position);

		return false;
	});

	let hash = location.hash;
	let hash_pos = 0;
	if(hash){
		if(hash.length > 2 && $(hash).length){
			hash_pos = $(hash).offset().top;

			setTimeout(function(){
				autoScroll(hash_pos,3000);
			},1000)
			
		}
	}
});

var autoScroll = function(position_px,speed = 750){
	// let speed = 750;
	//speed = Math.abs((position - $(window).scrollTop())/5);
	$("html, body").animate({ scrollTop: position_px }, speed, "swing" ,function(){
		// location.hash = href;
		// $.scrollify.disable();
		isAnchorScroll = false;
		cmnScrollHandler();
	});
}

var cmnLoadedHandler = function(){

	if(!isFirstLoaded){
		isFirstLoaded = true;
		kvAnim.show();
	}

}

var cmnBreakHandler = function(mode){
	console.log('reset');
	localNav.reset();
}


var cmnScrollHandler = function(){
	var scrpx = $(window).scrollTop();
	var docH = $(document).innerHeight(); //ページ全体の高さ
	var innerH = $(window).innerHeight() ? $(window).innerHeight() : $(window).height();
	var page_bottom = scrpx + innerH;
	var bottom_margin = 0;
	var btmpx = scrpx + innerH;
	var centerpx = scrpx + innerH /2;
	var margin = ua.isTouchDevice? -100 : 0;

	if($('.fv_cont2').length > 0){
		if(scrpx > 20 && !$('.fv_cont2').hasClass('hide')){
			$('.fv_cont2').addClass('hide');
		}else if(scrpx < 20 && $('.fv_cont2').hasClass('hide')){
			$('.fv_cont2').removeClass('hide');
		}
	}
	if(typeof noAnim === 'undefined'){
		
		let kvbox_btm = $('.kv_scrl_block').eq(0).offset().top + $('.kv_scrl_block').eq(0).height();
		let kvbox_last = $('.kv_scrl_block').last().offset().top + $('.kv_scrl_block').last().height();


		if(!$('.product_kv').hasClass('bye') && btmpx > kvbox_btm){
			$('.product_kv').addClass('bye');
			$('.fv_cont').addClass('hide');
			kvAnim.step1();
		}else if($('.product_kv').hasClass('bye') && btmpx <= kvbox_btm && kvAnim.copy_step > 0){
			$('.product_kv').removeClass('bye');
			$('.fv_cont').removeClass('hide');
			kvAnim.step0();
		}

		if(!$.scrollify.isDisabled() && btmpx > kvbox_last){
			$('.product_kv').addClass('end');
			$.scrollify.disable();	
			kvAnim.leave();
			$('.product_kv_bg_wrap').addClass('absolute');
			kvAnim.step99(0);
		}else if($.scrollify.isDisabled() && btmpx <= kvbox_last && !isAnchorScroll){
			let last_index = $('.kv_scrl_block').index($('.kv_scrl_block').last());
			$('.product_kv').removeClass('end');
			$.scrollify.enable();
			$('.product_kv_bg_wrap').removeClass('absolute');
			kvAnim.step99(1);
			localNav.set(0);
		}


		// if(!$('.product_kv').hasClass('end') && btmpx > kvbox_last){
		// 	$('.product_kv').addClass('end');
		// 	// $.scrollify.disable();
		// 	$('.product_kv_bg_wrap').addClass('absolute');
		// 	// $('.fv_area').velocity({opacity:0,marginTop:-150},500);
		// 	// kvAnim.leave();
		// }else if($('.product_kv').hasClass('end') && btmpx <= kvbox_last){
		// 	$('.product_kv').removeClass('end');
		// 	// $.scrollify.enable();
		// 	$('.product_kv_bg_wrap').removeClass('absolute');
		// 	// $('.fv_area').velocity({opacity:1,marginTop:0},500);
		// }

		if(!isScrollifyMove){
			$('.kv_scrl_block').each(function(i,elm){
				let top = $(elm).offset().top;
				let btm = $(elm).offset().top + $(elm).height();
				if(!$(elm).hasClass('go') && btmpx > top && btmpx <= btm){
					kvAnim.leave();
					kvAnim.copyStep($('.kv_scrl_block').eq(i),i);
				}
			});
		}
	}

	$('.ready').each(function (i, elm) {

		let $t = $(this);
		let targetTop = ($t.offset().top - innerH * 0.5);
		let targetBtm = ($t.offset().top + $t.height());

		if ((scrpx >= targetTop + margin && scrpx < targetBtm)) {
			let key = $t.parent().attr('data-section-key')? $t.parent().attr('data-section-key') : 0;

			localNav.set(key);
			
			if(!$t.hasClass('go')){
				$t.addClass('go');

				if($t.find('video.scrplay').length){
					$t.find('video').get(0).play();
				}
			}
		} 
	});
}

var localNav = {
	$nav:null,
	current:0,
	init:function(){
		var t = this;
		this.$nav = $('.local_menu_nav li');

		$('.sp_open_btn').click(function(){
			// $('.local_menu_nav').toggleClass('open');
			// $('.local_menu_nav').slideToggle(750,'swing');
			if($('.local_menu_nav').hasClass('open')){
				t.close();
			}else{
				t.open();
			}
		});

		$('.local_menu_nav .close').click(function(){
			t.close();
			return false;
		})
		$('.local_menu_nav li a').click(function(){
			t.reset();
		})
	},
	reset:function(){
		$('.local_menu_nav').attr('style','');
		$('.local_menu_nav').removeClass('open');
		$('.sp_open_btn').removeClass('open');
	},
	set:function(key){
		var t = this;
		// console.log(t.current,key);
		t.$nav.eq(t.current).find('a').removeClass('active');
		t.$nav.eq(key).find('a').addClass('active');

		let txt = t.$nav.eq(key).find('a').text();
		$('.sp_open_btn').text(txt);

		t.current = key;
	},
	open:function(){
		$('.local_menu_nav').slideDown(400,'swing').addClass('open');
		$('.sp_open_btn').addClass('open');
	},
	close:function(){
		$('.local_menu_nav').slideUp(400,'swing').removeClass('open');
		$('.sp_open_btn').removeClass('open');
	},
}